import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.replace";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import Text from '../../Atoms/Text/Text';
import Logo from '../../Atoms/Logo/Logo';
import FooterNav from './Nav/Nav';
import SocialIcons from '../../Atoms/SocialIcons/SocialIcons';
import { FooterWrapper, InnerWrapper, FooterBranding, FooterCopyright, SocialIconWrapper, Brand } from './Footer.style';

var Footer = function Footer(_ref) {
  var navItems = _ref.navItems,
      footerCopy = _ref.footerCopy,
      campaign = _ref.campaign,
      rest = _objectWithoutProperties(_ref, ["navItems", "footerCopy", "campaign"]); // Remove white space between words


  var campaignName = campaign.replace(/\s/g, '').toLowerCase();
  return React.createElement(FooterWrapper, Object.assign({
    navItems: true
  }, rest), React.createElement(InnerWrapper, null, React.createElement(SocialIconWrapper, null, React.createElement(SocialIcons, {
    campaign: campaignName
  })), React.createElement(FooterNav, {
    navItems: navItems
  }), React.createElement(FooterBranding, null, React.createElement(Brand, {
    href: "/",
    title: "Go to ".concat(campaign, " homepage")
  }, React.createElement(Logo, {
    sizeSm: "70px",
    sizeMd: "70px",
    rotate: true,
    campaign: campaign
  }))), React.createElement(FooterCopyright, null, React.createElement(Text, {
    tag: "p",
    color: "white"
  }, footerCopy))));
};

Footer.defaultProps = {
  navItems: {},
  footerCopy: '',
  campaign: 'Comic Relief'
};
export default Footer;